import React from 'react';  
import { useTranslation } from 'react-i18next';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';

const InputFilter = ({ placeholder, onchange, icon, paramkey, type }) => {  

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const pathname = location.pathname;
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    const handleSearch = useDebouncedCallback( (term) => {
        const params = new URLSearchParams(searchParams);  
        if (term) {
          params.set(`${paramkey}`,term);
        }
        else
          params.delete(`${paramkey}`);
          navigate(`${pathname}?${params.toString()}`);
    },1700);

    const handleChange = (e) => {
        const value = e.target.value;

        if(onchange)
            onchange(e);
    
        handleSearch(value);
    };
    return (  
        <div className="relative">  
            <span className={`absolute ${currentLang === "en" ? "right-3" : "left-3 "}  top-1/2 transform -translate-y-1/2 text-whtie`}>  
                {icon}
            </span>  
            <input  
                type={type ? type : "text"}    
                onChange={handleChange}  
                placeholder={placeholder}  
                className={`block w-full h-10  ${currentLang === "en" ? "pl-2 pr-2" : "pl-10 pr-3 "} bg-thirdly border border-gray-500/100 rounded-md text-white [color-scheme:dark]`}
            />  
        </div>  
    );  
};  

export default InputFilter;